/**
 * Per-section has_data guards for dashboard surfaces.
 * A section renders only when it has the data it needs; otherwise empty state or hide.
 */

/** Holdings need a price time-series (not a one-off snapshot). */
export function holdingHasPerformanceSeries(holding) {
  if (!holding) return false;
  const history = holding.price_history || holding.performance_series;
  return Array.isArray(history) && history.length >= 2;
}

export function portfolioHasPerformerData(portfolioData) {
  const holdings = portfolioData?.holdings || [];
  if (!holdings.length) return false;
  return holdings.some(holdingHasPerformanceSeries);
}

export function getBestWorstPerformers(portfolioData) {
  const holdings = (portfolioData?.holdings || []).filter(holdingHasPerformanceSeries);
  if (!holdings.length) return { best: null, worst: null };

  const ranked = holdings
    .map((h) => {
      const history = h.price_history || h.performance_series || [];
      const first = Number(history[0]?.value ?? history[0]?.price);
      const last = Number(history[history.length - 1]?.value ?? history[history.length - 1]?.price);
      if (!first || !last) return null;
      const gainPct = ((last - first) / first) * 100;
      return {
        symbol: h.symbol || h.ticker || '—',
        gainPct,
      };
    })
    .filter(Boolean);

  if (!ranked.length) return { best: null, worst: null };

  const best = ranked.reduce((a, b) => (b.gainPct > a.gainPct ? b : a));
  const worst = ranked.reduce((a, b) => (b.gainPct < a.gainPct ? b : a));
  return { best, worst };
}

export function portfolioHasDailyChange(portfolioData) {
  if (!portfolioData) return false;
  return (
    portfolioData.daily_change != null &&
    Number.isFinite(Number(portfolioData.daily_change))
  );
}

export function savingsRateChartReady(savingsRateTrend) {
  return Array.isArray(savingsRateTrend) && savingsRateTrend.length >= 2;
}
